import { useEffect, useRef } from "react";
import "@/App.css";
import Lenis from "lenis";
import { useSEO } from "./seo";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import BothSides from "@/components/BothSides";
import Statement from "@/components/Statement";
import Features from "@/components/Features";
import PhoneTease from "@/components/PhoneTease";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

function Home() {
  useSEO({
    title: "nailtape™ — The standard for the modern press-on business",
    description:
      "Business infrastructure for the press-on industry: the Checkflow System™, digital nail sizing, style library + Moodbox™, and business analytics. Free 7-day trial on the App Store.",
    path: "/home",
  });
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const hash = a.getAttribute("href");
      if (hash.length > 1 && document.querySelector(hash)) {
        e.preventDefault();
        lenis.scrollTo(hash, { offset: -70, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="min-h-screen bg-bone text-ink">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <BothSides />
        <Statement />
        <Features />
        <PhoneTease />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default Home;
